import axioInstance from "@/libs/axios";

export type GetQuoteFilter = {
  affiliate?: string | null;
  quoteId?: string | null;
  myAccountUserId?: string | null;
  policy?: string | null;
};

const fetchQuoteData = async (getQuoteFilter: GetQuoteFilter) => {
  const { affiliate, quoteId, policy } = getQuoteFilter;

  let getQuoteUrl = `/quote`;
  if (quoteId && affiliate) {
    const application = process.env.NEXT_PUBLIC_APPLICATION;
    if (application === "renewal") {
      getQuoteUrl = `${getQuoteUrl}/${quoteId}`;
    } else {
      getQuoteUrl = `${getQuoteUrl}/${quoteId}${
        affiliate ? `?affiliate=${affiliate}` : ""
      }`;
    }
    await axioInstance.post(`/createCookie`);
  }
  if (policy) {
    getQuoteUrl = `${getQuoteUrl}?policy=true`;
  }

  // const url = `/quote${quoteId ? `/${quoteId}` : ""}${affiliate ? `?affiliate=${affiliate}` : ""}`;
  const result = await axioInstance.get(getQuoteUrl);
  return result?.data?.data;
};

export default fetchQuoteData;
